import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/team.json";

// "Sectors" is a multi-select category field on Team, holding Sector ids.
const itemSectors = (item) => (Array.isArray(item.sectors) ? item.sectors : []);

export const useTeam = ({ __sector = null } = {}) => {
  let items = useSourceFlowCollection(data).map((i) => ({
    ...i,
    sectors: itemSectors(i),
    href: `/about-us/meet-team/${i.url_slug}`,
  }));

  if (__sector) {
    items = items.filter((i) => i.sectors.includes(__sector));
  }

  return items;
};

export default useTeam;
